import { render, staticRenderFns } from "./CommunicationManagementReport.vue?vue&type=template&id=162229f3&scoped=true"
import script from "./CommunicationManagementReport.vue?vue&type=script&lang=js"
export * from "./CommunicationManagementReport.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CommunicationManagementReport.vue?vue&type=style&index=1&id=162229f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162229f3",
  null
  
)

export default component.exports